import React, { useState } from "react";
import { Modal, Image } from "antd";

const TaskInfo = ({ visible, cancel, detailData }) => {
  return (
    <Modal
      title="巡检任务详情"
      width={600}
      open={visible}
      onOk={() => cancel()}
      onCancel={() => cancel()}
    >
      <div className="task-wrap">
        <div className="task-name">{detailData.name}</div>
        <div className="task-list">
          {detailData.devices &&
            detailData.devices.length > 0 &&
            detailData.devices.map((item, index) => {
              return (
                <div className="task-item" key={index}>
                  <div className="task-item-unit">
                    工艺单元：{item.deviceProcessunitName}
                  </div>
                  <div className="task-item-deviceName">
                    {item.deviceRelevancyName}
                  </div>
                  <div className="task-items">
                    {item.taskItems &&
                      item.taskItems.length > 0 &&
                      item.taskItems.map((subItem, subIndex) => {
                        return (
                          <div className="task-items-item" key={subIndex}>
                            {subItem.numericFlag ? (
                              <div className="task-items-left">
                                {subIndex + 1}、{subItem.itemContent}(
                                {subItem.lowerLimit}-
                                {subItem.upperLimit
                                  ? subItem.upperLimit
                                  : "无上限"}
                                )
                              </div>
                            ) : (
                              <div className="task-items-left">
                                {subIndex + 1}、{subItem.itemContent}
                              </div>
                            )}
                            <div className="task-items-right">
                              {!subItem.numericFlag && (
                                <div className="task-items-right-btns">
                                  <span
                                    className={
                                      subItem.isNormal == 1
                                        ? "task-items-right-btns-success"
                                        : ""
                                    }
                                  >
                                    正常
                                  </span>
                                  <span
                                    className={
                                      subItem.isNormal == 0
                                        ? "task-items-right-btns-error"
                                        : ""
                                    }
                                  >
                                    异常
                                  </span>
                                </div>
                              )}
                              {subItem.numericFlag == 1 && (
                                <div className="task-items-right-btns">
                                  {subItem.numericValue - 0 >=
                                    subItem.lowerLimit - 0 &&
                                  subItem.numericValue - 0 <=
                                    subItem.upperLimit - 0 ? (
                                    <span className="task-items-right-btns-success">
                                      数值为：{subItem.numericValue}单位为：
                                      {subItem.unit}
                                    </span>
                                  ) : (
                                    <span className="task-items-right-btns-error">
                                      数值为：{subItem.numericValue}单位为：
                                      {subItem.unit}
                                    </span>
                                  )}
                                </div>
                              )}
                            </div>
                            {subItem.imageUrls.length > 0 && (
                              <div className="task-items-images">
                                {subItem.imageUrls.map((attr, index) => {
                                  <Image key={index} width={100} src={attr} />;
                                })}
                              </div>
                            )}
                          </div>
                        );
                      })}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </Modal>
  );
};

export default TaskInfo;
